var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound22E = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 51",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M31 27.6a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM14.25 2.055h1.875V16.6h-.773c-.925 0-1.647-1.857-1.555-3.998l.453-10.547ZM31.75 2.055h-1.875V16.6h.773c.925 0 1.647-1.857 1.555-3.998L31.75 2.055ZM16.125 2.055h13.75v14.546h-13.75z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M33 2.055c0 .803-.28 1.454-.625 1.454h-18.75c-.345 0-.625-.65-.625-1.454C13 1.25 13.28.6 13.625.6h18.75c.345 0 .625.651.625 1.455Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28.207 47.726A2.5 2.5 0 0 1 25.717 50h-5.433a2.5 2.5 0 0 1-2.49-2.274l-.546-6A2.5 2.5 0 0 1 19.738 39h6.525a2.5 2.5 0 0 1 2.49 2.726l-.546 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M26.262 49c.687 0 1.314-.388 1.621-1.002l.223-.445a1 1 0 0 1 1.789.894l-.223.445A3.813 3.813 0 0 1 26.262 51h-6.524a3.812 3.812 0 0 1-3.41-2.108l-.222-.445a1 1 0 0 1 1.789-.894l.222.445A1.813 1.813 0 0 0 19.738 49h6.524Z",
  clipRule: "evenodd"
})));
SvgRound22E.viewBox = '0 0 46 51';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound22E);
export default ForwardRef;